import { Observable } from 'rxjs';

export enum TYPE_SEARCH {
  LOCAL = 'local',
  SERVICE = 'service'
}

export type SingleSelectServiceFn<T = any> = (term: string) => Observable<T[]>;
